

// LOCAL
//const SERVERURL =  'http://localhost:3000/api/'


// LIVE
const SERVERURL =  'https://app.infludata.com/api/'

module.exports = { SERVERURL }